import React, { useContext } from "react";
import ConstituentButtons, { ConstituentButtonsType } from "../ConstituentButtons";
import CommonModal from "./CommonModal";
import { TranslationContext } from "@src/components/translation/TranslationContext";

const LoginModal = (props) => {
  const t = useContext(TranslationContext);

  return (
    <CommonModal headerText={t.translate("components.login.log_in_to_classdojo")} {...props}>
      <ConstituentButtons responsive type={ConstituentButtonsType.LOGIN} buttonLocation="header" />
    </CommonModal>
  );
};

export default LoginModal;
